import React, { useRef, useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";

const ChatPage = () => {
  const [params] = useSearchParams();

  // Supplier coming from SupplierList
  const supplierId = params.get("supplier_id");
  const supplierName = params.get("name");

  const fileInputRef = useRef(null);

  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supportMessage, setSupportMessage] = useState({
    subject: "",
    content: "",
  });
  console.log(selectedSupplier,"selectedSupplier")
  const [errorSupportMessage, setErrorSupportMessage] = useState({});
  const [itemPics, setItemPics] = useState([]);
  const [loader, setLoader] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.id;

  /* ---------------- INIT SUPPLIER TAB ---------------- */
  useEffect(() => {
    if (supplierId && supplierName) {
      setSelectedSupplier({
        id: supplierId,
        name: supplierName,
      });
    }
  }, [supplierId, supplierName]);

  /* ---------------- HANDLERS ---------------- */
  const handleChange = (e, key) => {
    setSupportMessage((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleFileSelect = (e) => {
    const files = [...e.target.files];
    setItemPics(files.map((f) => URL.createObjectURL(f)));
  };

  /* ---------------- SEND MESSAGE ---------------- */
  const sendMessage = async () => {
    let error = {};
    if (!supportMessage.subject.trim()) error.subject = true;
    if (!supportMessage.content.trim()) error.content = true;

    setErrorSupportMessage(error);
    if (Object.keys(error).length) return;

    try {
      setLoader(true);

      const allImages = await Promise.all(
        itemPics.map(async (url) => {
          const res = await fetch(url);
          const blob = await res.blob();
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        })
      );

      const payload = {
        sender_id: userId,
        receiver_id: selectedSupplier.id,
        subject: supportMessage.subject,
        content: supportMessage.content,
        allImages,
        context: "CONTACT",
      };

      const res = await apicall.post(payload, "contact");

      if (res?.success) {
        toast.success("Message sent");
        setSupportMessage({ subject: "", content: "" });
        setItemPics([]);
      } else {
        toast.error(res?.message || "Failed to send");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="d-flex" style={{ height: "100vh", background: "#f5f6f8" }}>
      
      {/* ================= SIDEBAR ================= */}
      <aside
        style={{
          width: 260,
          background: "#fff",
          borderRight: "1px solid #e5e5e5",
        }}
      >
        <div className="p-3 border-bottom">
          <h6 className="fw-bold mb-0">Chats</h6>
        </div>

        {/* Supplier Tab */}
        <div
          className={`p-3 chat-tab ${
            selectedSupplier ? "active" : ""
          }`}
          style={{
            cursor: "pointer",
            background: selectedSupplier ? "#f1f1f1" : "transparent",
          }}
          onClick={() =>
            setSelectedSupplier({
              id: supplierId,
              name: supplierName,
            })
          }
        >
          <strong>{supplierName}</strong>
          <div className="text-muted small">Supplier</div>
        </div>
      </aside>

      {/* ================= CHAT PANEL ================= */}
      <main className="flex-grow-1 d-flex flex-column">
        
        {/* -------- Chat Header -------- */}
        <div className="p-3 bg-white border-bottom">
          <h6 className="mb-0">{selectedSupplier?.name}</h6>
          <small className="text-muted">Supplier Chat</small>
        </div>

        {/* -------- Messages Area -------- */}
        <div className="flex-grow-1 p-3 overflow-auto">
          <p className="text-muted text-center mt-5">
            Start a conversation with {selectedSupplier?.name}
          </p>
        </div>

        {/* -------- Input Box -------- */}
        <div className="bg-white border-top p-3">
          <Form>
            <Form.Group className="mb-2">
              <Form.Control
                size="sm"
                placeholder="Subject"
                value={supportMessage.subject}
                onChange={(e) => handleChange(e, "subject")}
                isInvalid={errorSupportMessage.subject}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Control
                as="textarea"
                rows={3}
                size="sm"
                placeholder="Type your message..."
                value={supportMessage.content}
                onChange={(e) => handleChange(e, "content")}
                isInvalid={errorSupportMessage.content}
              />
            </Form.Group>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                <label
                  htmlFor="fileUpload"
                  className="btn btn-outline-secondary btn-sm"
                >
                  Attach
                </label>
                <input
                  id="fileUpload"
                  ref={fileInputRef}
                  type="file"
                  multiple
                  hidden
                  onChange={handleFileSelect}
                />
                {itemPics.length > 0 && (
                  <small className="ms-2 text-muted">
                    {itemPics.length} file(s)
                  </small>
                )}
              </div>

              <Button
                size="sm"
                disabled={loader || !selectedSupplier}
                onClick={sendMessage}
                style={{
                  background: "#d01c4c",
                  border: "none",
                  borderRadius: 8,
                  minWidth: 80,
                }}
              >
                {loader ? "Sending..." : "Send"}
              </Button>
            </div>
          </Form>
        </div>
      </main>
    </div>
  );
};

export default ChatPage;
